RivalIQ.module('export.behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.Quota = Marionette.Behavior.extend({
        onBeforeShow: function () {
            const me = this;
            const account = RivalIQ.state.account;

            if (account.isAtTrialReportLimit()) {
                return me.showReportLimitReached();
            }

            if (account.hasTrialReportLimits() && !_.get(me, ['options', 'redactTrialReportLimit'], false)) {
                return me.showReportLimit();
            }
        },

        showReportLimitReached: function () {
            const me = this;

            me.view.quotaRegion.show(new Marionette.ItemView({
                template: '#exportTrialQuotaWarningMessageTemplate',
                model: RivalIQ.state.account
            }));

            me.view.ui.saveBtn.attr('disabled', true);
        },

        showReportLimit: function () {
            const me = this;

            me.view.quotaRegion.show(new Marionette.ItemView({
                template: '#exportTrialQuotaMessageTemplate',
                model: RivalIQ.state.account
            }));
        }
    });
});
